import React, { useEffect, useState } from "react";
import { addCity, getAllCountry, getStates } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddCity = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        country_id: "",
        state_id: "",
        name: "",
        avg_cost_living: ""
    });
    const [loader, setLoader] = useState(false);
    const [state, setState] = useState([]);
    const [country, setCountry] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await addCity(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getStateCall = async () => {
        let { ok, data } = await getStates({});
        if (ok) {
            setState(data?.records);
        }
    };

    const getCountryCall = async () => {
        let { ok, data } = await getAllCountry({});
        if (ok) {
            setCountry(data?.records);
        }
    };

    useEffect(() => {
        getStateCall();
        getCountryCall();
        if (data?.data) {
            const { name, country_id, state_id, avg_cost_living,  id } = data?.data;
            setReqData({ name, country_id, state_id, avg_cost_living, id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add City" : "Edit City"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>State</label>
                                            <select required value={reqData?.state_id} onChange={(e) => handleChange("state_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {state?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>State</label>
                                            <select required value={reqData?.country_id} onChange={(e) => handleChange("country_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Country</option>
                                                {country?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Cost Of Living</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Average Cost Of Living"
                                                required
                                                value={reqData?.avg_cost_living}
                                                onChange={(e) => handleChange("avg_cost_living", e?.target?.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCity;